module.exports = __webpack_public_path__ + "7866a23ef8df1d99aef0a94fcf2f1d83.pdf";